import { connect } from 'react-redux';
import Bookshelf from './Bookshelf';

export default connect(null, {})(Bookshelf);
